<style lang="less" scoped>
.detail-mes-div{
    height:35px;
    line-height: 35px;
    padding: 16px;
    margin-bottom: 10px;
    font-size:14px;
}
.detail-title-div{
    width:150px;
    text-align: right;
    margin-right:50px;
}
.detail-btn{
    height:32px;
    margin-left: 45px;
}
.margin-rt-20{
    margin-right:20px;
}
.dialog-title-div{
    margin:15px 0px;
}
</style>

<template>
    <div class="detail-container">
        <div class="detail-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="detail-content-div">
            <div class="detail-content-header-div flex">
                <div class="left-page-title-div flex-1">{{pageTitle}}</div>
            </div>
            <div class="detail-content-body-div flex-1">
                <div class="flex detail-form-parent-div">
                    <div class="flex-1">
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">订单编号：</div>
                            <div>{{detailForm.orderNo}}</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">电桩编号：</div>
                            <div>{{detailForm.pileCode}}</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">充电电量：</div>
                            <div>{{detailForm.chargeVal}}&nbsp;&nbsp;kW·h</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">订单属性：</div>
                            <div>{{detailForm.orderPropertyName}}</div>
                            <el-button type="primary" size="small" class="detail-btn" v-if="detailForm.orderProperty == '02' && !detailForm.orderReplyEntity" @click="handleOrderDialog()">处理</el-button>
                            <el-button type="primary" size="small" class="detail-btn" v-else-if="detailForm.orderProperty == '02' && detailForm.orderReplyEntity" @click="seeOrderFun">查看</el-button>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">充电状态：</div>
                            <div>{{detailForm.chargeStepName}}</div>
                            <el-button type="primary" size="small" class="detail-btn" @click="toCloseOrder" :disabled="orderFlag">关闭订单</el-button>
                            <!-- <el-button type="primary" size="small" class="detail-btn" @click="toCloseOrder">关闭订单</el-button> -->
                            <el-dialog width="30%" title="" :visible.sync="orderDialogFormVisible">
                                <el-form :model="dialogForm" label-width="100px" ref="dialogForm" :rules="pageConfig.orderFormRules">
                                    <div class="">该操作会直接结束订单</div>
                                    <div class="">如有客户正在充电会强行停止充电</div>
                                    <div class=""></div>
                                    <el-form-item label="关闭原因" prop="chargeOverReason">
                                        <el-input style="width:320px;" size="small" v-model="dialogForm.chargeOverReason" placeholder="请输入关闭原因" maxlength="100"></el-input>
                                    </el-form-item>
                                        </el-form>
                                        <div slot="footer" class="dialog-footer">
                                            <el-button @click="firstDialogFormVisible = false" size="small">取 消</el-button>
                                            <el-button type="primary" size="small" @click="closeOrder('dialogForm')">确 定</el-button>
                                        </div>
                            </el-dialog>
                        </div>
                    </div>
                    <div class="flex-1">
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">客户手机号：</div>
                            <div>{{detailForm.custPhone || '--'}}</div>
                        </div>


                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">开始时间：</div>
                            <div>{{detailForm.beginTime}}</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">结束时间：</div>
                            <div>{{detailForm.endTime}}</div>
                        </div>
                        <div class="detail-mes-div flex">
                            <div class="detail-title-div">充电时长：</div>
                            <div>{{detailForm.chargeTime}}</div>
                        </div>
                    </div>
                    <el-dialog title="订单详情" :visible.sync="dialogVisible" width="40%" @close="handleDialogClose('detailForm')">
                        <el-form :model="detailForm" :rules="pageConfig.formRules" ref="detailForm" label-width="150px">
                            <div class="flex" v-if="orderStatusFlg">
                                <div class="margin-rt-20">实收金额：&nbsp;{{detailForm.tActFee}}元</div>
                                <div class="margin-rt-20">应收金额：&nbsp;{{detailForm.tActFee}}元</div>
                                <div class="margin-rt-20">充电量：&nbsp;{{detailForm.chargeVal}}Kw·h</div>
                            </div>
                            <div class="flex" v-else>
                                <div class="margin-rt-20">操作人：&nbsp;{{detailForm.createdByName}}</div>
                                <div class="margin-rt-20">操作时间：&nbsp;{{detailForm.createdWhen}}</div>
                            </div>
                            <div>
                                <div class="dialog-title-div">APP端处理：</div>
                                <div>
                                    <el-form-item label="是否退款" prop="refundStatus">
                                        <el-radio-group v-model="dialogForm.refundStatus" :disabled="!orderStatusFlg">
                                            <el-radio label="01">不予退款</el-radio>
                                            <el-radio label="02">退款</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item label="车主回执" prop="toCustReceipt">
                                        <el-input type="textarea" size='small' v-model="dialogForm.toCustReceipt" :disabled="!orderStatusFlg"></el-input>
                                    </el-form-item>
                                </div>
                                <el-divider></el-divider>
                                <div class="dialog-title-div">SaaS端处理：</div>
                                <div>
                                    <el-form-item label="服务费免征额（元）" prop="freeServiceFee">
                                        <el-input size='small'  v-model="dialogForm.freeServiceFee" :disabled="!orderStatusFlg"></el-input>
                                    </el-form-item>
                                    <el-form-item label="运营商回执" prop="serviceReceipt">
                                        <el-input type="textarea" size='small' v-model="dialogForm.serviceReceipt" :disabled="!orderStatusFlg"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                            <el-button size="small" @click="dialogVisible = false">取 消</el-button>
                            <el-button size="small" type="primary" @click="handleOrderFun('detailForm')" v-if="orderStatusFlg">确 定</el-button>
                        </span>
                    </el-dialog>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import pageConfig from './page-config';
    export default {
        data() {
            return {
                pageConfig,
                editFlag:false,
                pageTitle:'订单详情',
                // 默认值设置
                detailForm: {},
                dialogForm:{
                },
                orderReplyEntity:{},
                dialogVisible:false,
                orderStatusFlg:false,
                orderFlag:false,
                remarkShow: true,
                inputShow: false,
                btnShow: true,
                editShow: false,
                remark: '',
                orderDialogFormVisible: false
            }
        },
        methods: {
            //初始化表单内容 判断是否编辑模式
            init() {
                if(this.$route.query.id){
                    this.editFlag = true;
                    this.getFormInfo();
                }
            },
            // 获取表单信息
            getFormInfo(){
                let _ = this;
                _.$S.getFormInfo(_,_.$A.order.pileorder +'/'+_.$route.query.id,function(res){
                     _.detailForm = res.data.data;
                     _.orderReplyEntity = _.detailForm.orderReplyEntity;
                     if(_.detailForm.chargeStepCode == '02'){
                         _.orderFlag = true;
                     }

                });
            },
            //关闭订单详情
            handleDialogClose(formName){
                this.$refs[formName].clearValidate();
            },
            //打开订单属性弹窗
            handleOrderDialog(){
                this.dialogForm = this.detailForm;
                this.orderStatusFlg = true;
                this.dialogVisible = true;
            },
            //查看订单属性
            seeOrderFun(){
                let _ = this;
                if(_.detailForm.orderReplyEntity){
                    _.dialogForm = _.detailForm.orderReplyEntity;
                }
                this.orderStatusFlg = false;
                this.dialogVisible = true;
            },
            //关闭充电状态弹窗
            toCloseOrder(){
                this.orderDialogFormVisible = true;
            },
            //结束充电状态
            closeOrder(formName){
                let _ = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var obj = {
                            chargeStepCode:'02',
                            orderNo: _.detailForm.orderNo,
                            chargeOverReason: _.dialogForm.chargeOverReason,
                            id: _.$route.query.id
                        }
                        _.$H.post(_, _.$A.order.updatechargestep, obj).then(res => {
                            _.$U.success("关闭成功");
                            this.orderDialogFormVisible = false;
                            this.detailForm = {};
                            this.getFormInfo();
                        })
                    }
                });
                // if(this.detailForm.chargeStepCode != '02'){
                //     this.$confirm('该操作会直接结束订单，如有客户正在充电则会强行停止充电！是否继续关闭？')
                //     .then(_ => {
                //         this.$H.post(this,this.$A.order.updatechargestep,{chargeStepCode:'02',orderNo:this.detailForm.orderNo}).then(res => {
                //             this.$U.success('关闭成功');
                //             this.detailForm = {};
                //             this.init();
                //         })
                //         done();
                //     })
                //     .catch(_ => {});
                // }else{
                //     this.$U.success('订单已关闭');
                // }

            },
            //处理订单详情表单
            handleOrderFun(formName){
                let _ = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        _.$H.post(_,_.$A.order.dealorderreply,_.dialogForm).then(res => {
                            _.dialogVisible = false
                            _.detailForm = {};
                            _.init();
                        })
                    }
                });
            },
            //订单备注编辑模式
            openInput(){
                this.btnShow = false;
                this.editShow = true;
                this.remarkShow = false;
                this.inputShow = true;
                this.detailForm.remark = '';
            },
            //编辑表单提交
            toEdit(){
                let _ = this;
                _.$U.showLoading(_);
                var obj = {};
                obj.id = _.$route.query.id;
                obj.remark = _.remark;
                _.$H.post(_, _.$A.order.updateRemark, obj).then(res => {
                    _.$U.success("编辑成功")
                    _.btnShow = true;
                    _.editShow = false;
                    _.remarkShow = true;
                    _.inputShow = false;
                    _.getFormInfo();
                    _.$U.hideLoading(_);
                })
            },
        },
        mounted() {
            this.init();
        }
    }
</script>
